<template>
  <div class="game-basics-form f-body">
    <UIInput
      class="fullrow"
      :title="$t('Content Title')"
      v-model="localGame.title"
      :disabled="disableTitle"
      :required="true"
      rules="required|max:70"
    />
    <UIInput
      textarea
      defaultMinHeight
      class="inputdesc fullrow"
      v-if="localGame.ownership"
      v-model="localGame.ownership.description"
      :title="$t('Content ownership description')"
      :disabled="true"
      :instructions="$t('This description by the content creator may contain installation instructions.')"
    />
    <UIInput
      textarea
      defaultMinHeight
      class="inputdesc fullrow"
      v-model="localGame.description"
      :title="$t('Description')"
      :instructions="$t('This description will be visible to the customer in the HMD.')"
    />
    <div style="display: flex;  gap: 1.5em;">
      <div style="flex: 1 1 300px; background-color: #f9f9f9; padding: 1em; border-radius: 8px;">
        <UIFormItem
          :title="$t('Content Image')"
          :instructions="$t('This image will be seen by players when they preview your content in the launcher.')"
          :required="true"
        ></UIFormItem>
        <FileInputWithThumbnail
          id="image"
          type="image"
          :media="getMedia('image')"
          v-model="localGame.imageUrl"
          :specs="$t('Recommended Dimensions: 600x280px, 2MB maximum')"
          :required="false"
          :ratio="280 * 100 / 600"
          class="mt2"
          @input="onFileUploadInput"
          @clear="onFileUploadClear"
          :fieldNameOverride="$t('Content Image')"
        />
      </div>

      <!-- Content Trailer -->
      <div style="flex: 1 1 300px; background-color: #f9f9f9; padding: 1em; border-radius: 8px;">
        <UIFormItem
          :title="$t('Content Trailer')"
          :instructions="$t('This video will be seen by players when they preview your content in the launcher.')"
        ></UIFormItem>
        <FileInputWithThumbnail
          id="video"
          type="video"
          :media="getMedia('video')"
          :specs="$t('Recommended Dimensions: 600x280px, 2MB maximum')"
          :required="false"
          :ratio="280 * 100 / 600"
          class="mt2"
          @input="onFileUploadInput"
          @clear="onFileUploadClear"
          :fieldNameOverride="$t('Content Trailer')"
        />
        <div class="video-note" style="margin-top: 0.5em; font-size: 0.85em; color: #666;">
          {{ $t('NOTE: When left empty, the default trailer for this content will show. After uploading your video will be converted. This may take a few minutes!') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UIInput from '@/core/shared/components/ui/UIInput';
import UISelect from '@/core/shared/components/ui/UISelect';
import UIFormItem from '@/core/shared/components/ui/UIFormItem';
import FileUploadWithThumbnail from '@/core/shared/components/FileUploadWithThumbnail';
import FileInputWithThumbnail from '@/core/shared/components/FileInputWithThumbnail';
@Component({
  components: {
    UIInput,
    UISelect,
    UIFormItem,
    FileUploadWithThumbnail,
    FileInputWithThumbnail,
  },
  props: {
    game: { required: true },
    disableTitle: { type: Boolean },
  },
})
export default class GameBasicsForm extends Vue {
  get localGame () {
    return new Proxy(this.game, {
      get (obj, k) {
        return obj[k];
      },
      set: (obj, k, val) => {
        this.$emit('edit', k, val);
        return true;
      },
    });
  }

  getMedia (type) {
    const id = type;
    if (this.localGame[`_${type}Blob`]) {
      const blob = this.localGame[`_${type}Blob`];
      return { id, title: blob.title, src: blob.src };
    }
    if (this.localGame[`${type}Url`]) {
      return { id, title: '', src: this.localGame[`${type}Url`] };
    }
    return { id, title: '', src: '' };
  }

  async onFileUploadInput ({ id, src }) {
    if (id === 'image') {
      this.localGame.imageUrl = src;
    }
    if (id === 'video') {
      this.localGame.videoUrl = src;
    }
  }

  onFileUploadClear ({ id }) {
    if (`_${id}Blob` in this.localGame) {
      this.localGame[`_${id}Blob`] = null;
    } else {
      this.localGame[`${id}Url`] = null;
    }
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.game-basics-form {
  display: grid;
  column-gap: var(--spacingSm);
  row-gap: var(--spacingLg);
  grid-template-columns: 1fr;
  @media (--tablet) {
    grid-template-columns: 1fr 1fr;
  }
  & .fullrow {
    grid-column: 1 / -1;
  }
  & .video-note {
    @apply --f6;
    margin-top: 1rem;
    color: var(--colorSBRedFlat);
  }
}
</style>
